import { createStore, combineReducers, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';

import authReducer from '../reducers/authReducer';
import rootReducer from '../reducers/rootReducer';
import liaisonReducer from '../reducers/liaisonReducer';
import profileReducer from '../reducers/profileReducer';
import instructionsReducer from '../reducers/instructionsReducer';

export default () => {
  const store = createStore(
    combineReducers({
      auth: authReducer,
      root: rootReducer,
      liaison: liaisonReducer,
      profile: profileReducer,
      instructions: instructionsReducer
    }),
    window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__(),
    applyMiddleware(thunk)
  );
  return store;
}


// WEBPACK FOOTER //
// ./src/store/store.jsx